import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryurbaniabushireinthane() {



    const cardData =
    {
        keyword: 'Luxury Urbania Bus Hire in Thane',
        heading: 'Urbania on rent in pune: Luxury Urbania Bus Hire in Thane',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Luxury Urbania Bus Hire in Thane services for corporate groups, families, tourists, and event travelers commuting between Pune and Thane. Our well‑maintained Luxury Force Urbania buses provide spacious seating, plush interiors, powerful air‑conditioning, and smooth performance, making them ideal for long‑distance travel, airport transfers, corporate outings, weddings, sightseeing, and outstation journeys from Pune to Thane and vice versa. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from key locations including Pune Airport, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, and Pimpri Chinchwad, we ensure a comfortable, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for luxury Urbania bus hire to Thane.',

        top: 'Top Places to Visit in Navi Thane with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Upvan Lake",
    "description": "Upvan Lake, located in Thane, is a serene freshwater lake surrounded by lush greenery and walking tracks. It is famous for hosting the annual Sanskruti Arts Festival and serves as a hub for morning walks, yoga, and boating activities. The tranquil waters and scenic surroundings make it a popular spot for families, couples, and nature lovers seeking peace in the city."
  },
  {
    "title": "Yeoor Hills",
    "description": "Yeoor Hills, part of the Sanjay Gandhi National Park, are located near Thane and offer excellent trekking trails, nature walks, and birdwatching opportunities. The hills are covered with dense forests, streams, and waterfalls, making it an ideal destination for adventure enthusiasts, photographers, and weekend hikers."
  },
  {
    "title": "Tikuji-ni-Wadi",
    "description": "Tikuji-ni-Wadi is an amusement and water park in Thane featuring rides, slides, and entertainment zones suitable for families and children. Visitors enjoy fun activities, cultural shows, and picnic spots. The park’s combination of water attractions and dry rides makes it a popular recreational destination near Mumbai."
  },
  {
    "title": "Korum Mall",
    "description": "Korum Mall in Thane is a modern shopping and entertainment complex with retail stores, restaurants, cinemas, and leisure areas. It provides a comfortable environment for shopping, dining, and social gatherings, attracting locals and tourists alike."
  },
  {
    "title": "Suraj Water Park",
    "description": "Suraj Water Park is a popular water-based amusement park offering pools, slides, and adventure rides. It is perfect for family outings, birthday parties, and group recreation, especially during hot summer months. The park emphasizes fun, safety, and relaxation."
  },
  {
    "title": "Thane Creek Flamingo Sanctuary",
    "description": "The Thane Creek Flamingo Sanctuary is a protected area home to thousands of flamingos and other migratory birds. Visitors enjoy birdwatching, photography, and learning about local biodiversity. The sanctuary highlights the ecological significance of Thane Creek and its role in supporting wildlife."
  },
  {
    "title": "Masunda Lake (Talav Pali)",
    "description": "Masunda Lake, also known as Talav Pali, is a scenic urban lake in Thane. The promenade around the lake is ideal for evening walks, jogging, and recreational activities. Street food vendors, boating facilities, and well-maintained pathways make it a lively and enjoyable spot for locals and tourists."
  },
  {
    "title": "Shri Jagdish Temple",
    "description": "Shri Jagdish Temple is a spiritual landmark in Thane dedicated to Lord Vishnu. The temple is known for its intricate architecture, peaceful ambiance, and regular religious festivities. Devotees visit to seek blessings, meditate, and participate in cultural rituals."
  },
  {
    "title": "Nerul Water Park",
    "description": "Located in the Thane region, Nerul Water Park is an entertainment hub with slides, pools, and recreational zones. Families and children visit for fun-filled activities, picnics, and leisure experiences, making it a favorite weekend getaway spot."
  },
  {
    "title": "Smt. Chandibai H. Thakur College Garden",
    "description": "This garden is a tranquil green space maintained by the local college in Thane. It features walking paths, landscaped greenery, and peaceful areas for relaxation. Students, locals, and visitors enjoy nature walks, photography, and quiet moments amidst the city’s bustle."
  }
],



"services": [
{
"name": "Luxury Urbania Bus Hire in Thane",
"description": "Luxury Urbania Bus Hire in Thane offers fully air-conditioned high-end Urbania buses with plush seating, spacious interiors, and modern amenities. Ideal for group travel, corporate events, weddings, and family tours, these vehicles ensure a safe, comfortable, and stylish journey. Professional chauffeurs, timely pickups, and personalized service make every trip hassle-free and memorable."
},
{
"name": "Thane Luxury Urbania Rental",
"description": "Thane Luxury Urbania Rental provides premium air-conditioned Urbania vehicles designed for luxury travel and executive comfort. Perfect for VIP travel, corporate trips, outstation journeys, and special occasions, the service ensures punctuality, safety, and an enjoyable travel experience for all passengers."
},
{
"name": "Premium Urbania Bus Thane",
"description": "Premium Urbania Bus Thane offers high-end, well-maintained Urbania buses equipped with climate control, comfortable seating, and entertainment options. Suitable for corporate outings, group tours, weddings, and long-distance travel, this service combines reliability with luxury to create a seamless travel experience."
},
{
"name": "Urbania AC Luxury Bus Thane",
"description": "Urbania AC Luxury Bus Thane provides fully air-conditioned Urbania buses designed for comfort, convenience, and smooth rides. Ideal for city tours, intercity travel, corporate events, and social gatherings, the buses come with trained chauffeurs, ample luggage space, and attention to passenger needs."
},
{
"name": "Corporate Luxury Urbania Hire Thane",
"description": "Corporate Luxury Urbania Hire Thane delivers professional transportation solutions for office trips, executive meetings, conferences, and corporate events. Equipped with AC vehicles and experienced chauffeurs, it ensures punctuality, comfort, and a stress-free travel experience for business travelers."
},
{
"name": "Luxury Urbania for Outstation Thane",
"description": "Luxury Urbania for Outstation Thane offers safe and comfortable long-distance travel with well-maintained, air-conditioned buses and experienced chauffeurs. Ideal for corporate trips, family vacations, and group tours, this service emphasizes convenience, safety, and a premium travel experience."
},
{
"name": "Luxury Airport Transfer Urbania Thane",
"description": "Luxury Airport Transfer Urbania Thane ensures timely and hassle-free airport pickups and drops with spacious AC buses, professional chauffeurs, and luggage assistance. Perfect for VIP travelers, corporate guests, and family groups, it guarantees comfort and reliability for every airport transfer."
},
{
"name": "Chauffeur Driven Luxury Urbania Thane",
"description": "Chauffeur Driven Luxury Urbania Thane provides stress-free travel with highly trained, verified chauffeurs experienced in city and highway driving. Ideal for corporate executives, weddings, family outings, and VIP transport, this service combines safety, comfort, and professionalism."
},
{
"name": "Wedding Luxury Urbania Thane",
"description": "Wedding Luxury Urbania Thane offers elegant and fully air-conditioned Urbania buses for weddings, guest transport, and family travel. With spacious interiors, stylish design, and courteous chauffeurs, it ensures a premium and memorable experience for all wedding occasions."
},
{
"name": "Family Tour Luxury Urbania Thane",
"description": "Family Tour Luxury Urbania Thane provides air-conditioned Urbania buses for safe, comfortable, and enjoyable family trips. Perfect for outstation tours, sightseeing, and group excursions, the service focuses on convenience, spacious seating, and memorable travel experiences."
},
{
"name": "Best Luxury Urbania Rental Thane",
"description": "Best Luxury Urbania Rental Thane delivers top-rated, fully air-conditioned Urbania buses known for reliability, vehicle quality, and excellent customer service. Ideal for corporate events, weddings, family tours, and long-distance travel, it guarantees comfort, safety, and style."
},
{
"name": "Executive Urbania Hire Thane",
"description": "Executive Urbania Hire Thane provides high-end AC Urbania vehicles for corporate executives, VIPs, and special events. With professional chauffeurs, comfortable interiors, and timely service, it ensures a seamless and premium travel experience."
},
{
"name": "Comfortable Luxury Urbania Thane",
"description": "Comfortable Luxury Urbania Thane offers air-conditioned Urbania buses with spacious seating, smooth ride quality, and attentive chauffeur service. Perfect for family outings, group travel, and corporate trips, the service prioritizes passenger comfort and convenience."
},
{
"name": "High End Urbania Rental Thane",
"description": "High End Urbania Rental Thane delivers luxurious AC Urbania buses with modern amenities, plush interiors, and reliable service. Suitable for VIP travel, weddings, corporate events, and long-distance tours, it provides a safe and premium travel experience."
},
{
"name": "Trusted Luxury Urbania Service Thane",
"description": "Trusted Luxury Urbania Service Thane ensures dependable, stylish, and safe travel with fully air-conditioned Urbania buses. Ideal for corporate trips, family vacations, weddings, and group tours, the service focuses on punctuality, professionalism, and passenger satisfaction."
}
],
"tableData": [
["Luxury Urbania Bus Hire in Thane", "Thane Luxury Urbania Rental"],
["Premium Urbania Bus Thane", "Urbania AC Luxury Bus Thane"],
["Corporate Luxury Urbania Hire Thane", "Luxury Urbania for Outstation Thane"],
["Luxury Airport Transfer Urbania Thane", "Chauffeur Driven Luxury Urbania Thane"],
["Wedding Luxury Urbania Thane", "Family Tour Luxury Urbania Thane"],
["Best Luxury Urbania Rental Thane", "Executive Urbania Hire Thane"],
["Comfortable Luxury Urbania Thane", "High End Urbania Rental Thane"],
["Trusted Luxury Urbania Service Thane", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Luxury Urbania Bus Hire in Thane",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane is perfect for group travel, corporate trips, family outings, weddings, and outstation journeys, providing a comfortable and spacious experience."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Buses",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane offers premium Force Urbania buses with modern interiors, air-conditioning, ample legroom, and comfortable seating for long and short trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane comes with skilled drivers familiar with Thane, Mumbai, and nearby routes, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose Luxury Urbania Bus Hire in Thane for cost-effective and transparent rental rates with no hidden charges, making group travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Bus Rental Packages",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
        "WhyChoosedescription": "All vehicles for Luxury Urbania Bus Hire in Thane are regularly cleaned, sanitized, and maintained to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Bus Service",
        "WhyChoosedescription": "Luxury Urbania Bus Hire in Thane guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel for groups."
    }
]
}

const faqData = [
    {
        question: 'Is Luxury Urbania Bus Hire in Thane available for local and outstation travel?',
        answer: 'Yes, Luxury Urbania Bus Hire in Thane can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Luxury Urbania Bus Hire in Thane?',
        answer: 'You can book Luxury Urbania Bus Hire in Thane via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Luxury Urbania Bus Hire in Thane?',
        answer: 'Luxury Urbania Bus Hire in Thane offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Luxury Urbania Bus Hire in Thane are licensed, trained, and experienced in handling Force Urbania buses safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Luxury Urbania Bus Hire in Thane allows flexible pickup and drop locations across Thane, Mumbai, and nearby areas.',
    },
    {
        question: 'Is Luxury Urbania Bus Hire in Thane available 24x7?',
        answer: 'Yes, Luxury Urbania Bus Hire in Thane operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Luxury Urbania Bus Hire in Thane accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Luxury Urbania buses be used for corporate, family, and wedding trips?',
        answer: 'Yes, Luxury Urbania Bus Hire in Thane is ideal for corporate travel, family outings, airport transfers, wedding events, and outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Deshmukh',
        feedback: 'Luxury Urbania Bus Hire in Thane provided a comfortable and hassle-free ride for our corporate outing. Spacious and excellent service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Kulkarni',
        feedback: 'We hired Luxury Urbania Bus Hire in Thane for a wedding event. The bus was clean, luxurious, and punctual. Highly recommended.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Vikram Patil',
        feedback: 'Luxury Urbania Bus Hire in Thane made our group trip enjoyable and smooth. Professional driver and reliable service.',
        rating: 5,
    },
];

























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Urbania Bus Hire in Thane",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-thane.jpg",
  "description": "Luxury Urbania Bus Hire in Thane offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, family tours, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Thane and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/luxury-urbania-bus-hire-thane"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Luxury Urbania Bus Hire in Thane | AC & Premium Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Luxury Urbania Bus Hire in Thane for corporate trips, outstation travel, airport transfers, weddings, family tours, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Thane."
  />

  <meta
    name="keywords"
    content="Luxury Urbania Bus Hire in Thane, Thane Luxury Urbania Rental, Premium Urbania Bus Thane, Urbania AC Luxury Bus Thane, Corporate Luxury Urbania Hire Thane, Luxury Urbania for Outstation Thane, Luxury Airport Transfer Urbania Thane, Chauffeur Driven Luxury Urbania Thane, Wedding Luxury Urbania Thane, Family Tour Luxury Urbania Thane, Best Luxury Urbania Rental Thane, Executive Urbania Hire Thane, Comfortable Luxury Urbania Thane, High End Urbania Rental Thane, Trusted Luxury Urbania Service Thane"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryurbaniabushireinthane;